import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { IObjectCustomFields } from 'src/app/features/settings/models/settings.models';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ObjectCustomFieldsFormComponent } from 'src/app/shared/components/object-custom-fields-form/object-custom-fields-form.component';

@Component({
  selector: 'app-order-custom-fields',
  templateUrl: './order-custom-fields.component.html',
  styleUrls: ['./order-custom-fields.component.scss']
})
export class OrderCustomFieldsComponent implements OnInit {
  @ViewChild(ObjectCustomFieldsFormComponent) customFieldsForm?: ObjectCustomFieldsFormComponent;

  constructor(
    public dialogRef: MatDialogRef<OrderCustomFieldsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { objectCustomFields: IObjectCustomFields },
  ) { }

  ngOnInit(): void {
  }

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.customFieldsForm?.onSave();
  }

  saveOrderCustomFields(values: IObjectCustomFields['values']): void {
    this.dialogRef.close(values);
  }

}
